import React, { createContext, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider as MUIThemeProvider, createTheme } from "@mui/material/styles";
import { toggleTheme as toggleThemeAction } from "../features/theme/themeSlice";
import { getDesignTokens } from "../theme/theme"; 

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const customColors = useSelector((state) => state.theme.customColors);

  const toggleTheme = () => dispatch(toggleThemeAction());

  const theme = createTheme(
    getDesignTokens(isDarkMode ? "dark" : "light", customColors)
  );

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useCustomTheme = () => useContext(ThemeContext);
export const useTheme = useCustomTheme;